import React from "react";

import "./surface.m.css";

export function Surface({ children }) {
  return <div styleName="surface-wrapper">{children}</div>;
}

Surface.propTypes = {
  children: React.Children
};
